import React, { createContext, useState, useEffect } from "react";
import axios from "axios";
import { BASE_URL } from "../Assets/Constants";

export const CurrencyContext = createContext();

export const CurrencyProvider = ({ children }) => {
  const [currency, setCurrency] = useState(localStorage.getItem("currency") || "€");

  const fetchCurrency = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/user/setting`);
      const newCurrency = response?.data?.data?.currency;

      if (newCurrency && newCurrency !== currency) {
        setCurrency(newCurrency);
        localStorage.setItem("currency", newCurrency); 
      }
    } catch (error) {
      console.error("Error fetching currency setting:", error?.response);
    }
  };

  useEffect(() => {
    fetchCurrency();
  }, []);

  return (
    <CurrencyContext.Provider value={{ currency, setCurrency }}>
      {children}
    </CurrencyContext.Provider>
  );
};
